import React, { Component } from 'react';

import '../../../../chat.css';
import ChatResponseFeedbackEnum from '../../../../config/constants/ChatResponseFeedbackEnum'
import LikeIcon from "./LikeIcon";

/**
 * Class that shows like/dislike buttons for chat feedback.
 */
class ChatFeedback extends Component {

    constructor(props) {
        super(props);

        this.state = {
            likeButtonIsHovered: false,
            dislikeButtonIsHovered: false
        }
    }

    handleFeedbackButtonHover = (chatResponseFeedbackType) => {
        if (chatResponseFeedbackType === ChatResponseFeedbackEnum.like) {
            this.setState({likeButtonIsHovered: !this.state.likeButtonIsHovered});

        } else {
            this.setState({dislikeButtonIsHovered: !this.state.dislikeButtonIsHovered});
        }
    }

    handleButtonClick = (chatResponseFeedback) => {
        if (this.props.spectatorMode) {
            return;
        }

        if (this.props.speechBubble.chatResponseFeedback === chatResponseFeedback) {
            chatResponseFeedback = ChatResponseFeedbackEnum.notSet;
        }

        this.props.sendChatResponseFeedback(this.props.speechBubble.chatQuestionId, chatResponseFeedback);
    };

    render() {
        return(
            <div id={'chat-feedback-container'}>
                <div className={'chat-feedback-button' + (this.props.speechBubble.chatResponseFeedback === ChatResponseFeedbackEnum.dislike ? ' chat-feedback-button-dislike-clicked' : '')}
                     id={'chat-dislike-button'} onClick={() => this.handleButtonClick(ChatResponseFeedbackEnum.dislike)}
                     onMouseEnter={() => this.handleFeedbackButtonHover(ChatResponseFeedbackEnum.dislike)}
                     onMouseLeave={() => this.handleFeedbackButtonHover(ChatResponseFeedbackEnum.dislike)}>

                    {this.props.speechBubble.chatResponseFeedback === ChatResponseFeedbackEnum.dislike || this.props.spectatorMode === false ?
                        <LikeIcon color={this.props.speechBubble.chatResponseFeedback === ChatResponseFeedbackEnum.dislike || this.state.dislikeButtonIsHovered ? '#e57373' : null}/>
                    : null}
                </div>

                <div className={'chat-feedback-button' + (this.props.speechBubble.chatResponseFeedback === ChatResponseFeedbackEnum.like ? ' chat-feedback-button-like-clicked' : '')}
                     onClick={() => this.handleButtonClick(ChatResponseFeedbackEnum.like)}
                     onMouseEnter={() => this.handleFeedbackButtonHover(ChatResponseFeedbackEnum.like)}
                     onMouseLeave={() => this.handleFeedbackButtonHover(ChatResponseFeedbackEnum.like)}>

                    {this.props.speechBubble.chatResponseFeedback === ChatResponseFeedbackEnum.like || this.props.spectatorMode === false ?
                        <LikeIcon color={this.props.speechBubble.chatResponseFeedback === ChatResponseFeedbackEnum.like || this.state.likeButtonIsHovered ? '#81c784' : null}/>
                        : null}
                </div>
            </div>
        );
    }
}

export default ChatFeedback;
